import Axios from "@/plugins/Axios";

export class BancoHorasService {
  async getMeuSaldo() {
    const response = await Axios().get("/ponto-colaboradores/banco-horas/meu-saldo");
    return response.data;
  }

  async getMeuHistorico(params = {}) {
    const response = await Axios().get("/ponto-colaboradores/banco-horas/meu-historico", {
      params,
    });
    return response.data;
  }

  async getAdminSaldos(params = {}) {
    const response = await Axios().get("/ponto-colaboradores/admin/banco-horas/saldos", {
      params,
    });
    return response.data;
  }

  async getAdminPendencias(params = {}) {
    const response = await Axios().get("/ponto-colaboradores/admin/banco-horas/pendencias", {
      params,
    });
    return response.data;
  }

  async aprovar(id, data = {}) {
    const response = await Axios().post(
      `/ponto-colaboradores/admin/banco-horas/${id}/aprovar`,
      data
    );
    return response.data;
  }

  async reprovar(id, data = {}) {
    const response = await Axios().post(
      `/ponto-colaboradores/admin/banco-horas/${id}/reprovar`,
      data
    );
    return response.data;
  }

  async processar(params = {}) {
    const response = await Axios().post("/ponto-colaboradores/admin/banco-horas/processar", params);
    return response.data;
  }

  async getUsuarioHistorico(userId, params = {}) {
    const response = await Axios().get(
      `/ponto-colaboradores/admin/banco-horas/usuario/${userId}/historico`,
      {
        params,
      }
    );
    return response.data;
  }
}

export default new BancoHorasService();
